import * as React from "react";
import { HangarsStateContainer } from "../../containers/HangarsStateContainer";
import { HangarsPresenter } from "./HangarsPresenter";

type Props = {};

export const Hangars: React.FC<Props> = () => {
  return (
    <HangarsStateContainer isReference={false}>
      <HangarsPresenter />
    </HangarsStateContainer>
  );
};
